import axios from "axios";
import api from "./apiConfig";


export const getAllCustomers = async (data) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const customersCall = await api.get('/customers', { params: data, headers: { 'x-auth-token': localStorage.getItem('token') } })
            // console.log(customersCall)
            let status = customersCall?.data?.status;
            let successData = customersCall?.data?.data;
            let message = customersCall?.data.message;

            if (status !== 200) {
                resolve([{ message, status }, null])
            } else {
                resolve([null, successData])
            }
        } catch (error) {
            // send error back
            // reject(error)
            resolve([{ message: error, status: 500 }, null])
        }
    })
}

export const createCustomers = async (data) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const customersCall = await api.post('/customers', data, {
                headers: { 'x-auth-token': localStorage.getItem('token') }
            }); // submitting the array of customer objects

            let status = customersCall?.data?.status;
            let successData = customersCall?.data?.data;
            let message = customersCall?.data?.message;

            if (status !== 200) {
                resolve([{ message, status }, null]);
            } else {
                resolve([null, successData]);
            }
        } catch (error) {
            // send error back
            reject(error);
        }
    });
};


export const updateCustomer = async (customer) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const customerId = customer.id || customer._id;
            const response = await api.put(`/customers/${customerId}`, {
                ...customer,
            },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-auth-token': localStorage.getItem('token')
                    },
                }
            )
            // console.log(response)
            let status = response?.data?.status;
            let successData = response?.data?.data;
            let message = response?.data?.message;

            if (status !== 200) {
                resolve([{ message, status }, null]);
            } else {
                resolve([null, successData]);
            }  // Return the updated customer data
        } catch (error) {
            console.error('Error updating customer:', error);
            reject(error);
            // throw error;  // Re-throw the error to be caught in handleSubmit
        }
    })
};

export const deleteCustomer = async (customerId) => {
    return await new Promise(async (resolve, reject) => {
        try {
            // const customerId = customer.id || customer._id;
            const response = await api.delete(`/customers/${customerId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-auth-token': localStorage.getItem('token')
                },
            });
            // console.log(response)
            let status = response?.data?.status;
            let successData = response?.data?.data;
            let message = response?.data?.message;

            if (status !== 200) {
                resolve([{ message, status }, null]);
            } else {
                resolve([null, successData]);
            }
        } catch (error) {
            console.error('Error deleting customer:', error);
            reject(error);

        }
    })
};

export const getTotalCustomers = async () => {
    try {
        const response = await api.get(`/customers/total`, {
            headers: { 'x-auth-token': localStorage.getItem('token') }
        });
        return response.data.message.total;
    } catch (error) {
        throw error;
    }
};